import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Quote, Star } from "lucide-react";
import { TESTIMONIALS } from "@/data/site";
import { EASE, Reveal } from "@/components/motion/Reveal";
import { cn } from "@/lib/utils";

const DURATION = 7000;

export const Testimonials = ({ index = "08" }) => {
  const [i, setI] = useState(0);
  useEffect(() => {
    const t = setTimeout(() => setI((v) => (v + 1) % TESTIMONIALS.length), DURATION);
    return () => clearTimeout(t);
  }, [i]);
  const t = TESTIMONIALS[i];
  return (
    <section className="relative border-t border-white/5 bg-ink-900 py-28 lg:py-32" data-testid="testimonials-section">
      <div className="container-x grid gap-14 lg:grid-cols-12">
        <div className="lg:col-span-3">
          <Reveal>
            <p className="eyebrow"><span className="text-slate-500">{index} —</span> Partners</p>
            <p className="mt-5 font-display text-2xl font-bold leading-tight text-white">What business owners say</p>
            <div className="mt-6 flex gap-1">{[0, 1, 2, 3, 4].map((s) => <Star key={s} className="h-4 w-4 fill-volt text-volt" />)}</div>
          </Reveal>
        </div>
        <div className="relative min-h-[300px] lg:col-span-8 lg:col-start-5">
          <Quote className="absolute -left-2 -top-6 h-16 w-16 text-volt/15" />
          <AnimatePresence mode="wait">
            <motion.figure key={i} initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -20 }} transition={{ duration: 0.8, ease: EASE }} data-testid="testimonial-active">
              <blockquote className="relative font-display text-2xl font-medium leading-snug tracking-tight text-white sm:text-3xl lg:text-4xl">“{t.quote}”</blockquote>
              <figcaption className="mt-10 flex items-center gap-4">
                <span className="h-px w-10 bg-volt" />
                <span className="text-sm font-semibold text-white">{t.role}</span>
                <span className="font-mono text-[11px] uppercase tracking-[0.2em] text-slate-500">{t.place}</span>
              </figcaption>
            </motion.figure>
          </AnimatePresence>
          <div className="mt-12 grid grid-cols-3 gap-3">
            {TESTIMONIALS.map((_, k) => (
              <button key={k} onClick={() => setI(k)} className="group py-3 text-left" aria-label={`Show testimonial ${k + 1}`} data-testid={`testimonial-dot-${k + 1}`}>
                <span className="block h-px w-full overflow-hidden bg-white/10">
                  {k === i && <motion.span key={i} initial={{ scaleX: 0 }} animate={{ scaleX: 1 }} transition={{ duration: DURATION / 1000, ease: "linear" }} className="block h-px origin-left bg-volt" />}
                  {k < i && <span className="block h-px bg-white/40" />}
                </span>
                <span className={cn("mt-3 block font-mono text-[10px] uppercase tracking-[0.2em] transition-colors", k === i ? "text-white" : "text-slate-600 group-hover:text-slate-400")}>0{k + 1}</span>
              </button>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
